var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgZakyatLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 167,
    height: 29,
    viewBox: "0 0 167 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.50384 24.0248L26.5199 6.79802V12.9095L13.5954 23.5037H26.5199V28.2822H6.95265H0.309874L5.50384 24.0248ZM42.6108 0.378271L30.2467 28.1079H36.8251L39.297 22.1658H52.1559L54.6183 28.1079H61.3551L48.9514 0.378271H42.6108ZM45.739 6.68079L50.1368 17.2933H41.324L45.739 6.68079ZM70.6133 21.1081V28.1079H64.2331V0.378271H70.6133V13.3184L82.8981 0.378271H87.6724H90.0312H94.4886L101.883 12.688L109.31 0.378271H115.611L104.832 18.2898V28.1079H98.4118V18.224L88.5994 1.91861L78.5468 12.7328L90.705 28.1079H83.2152L74.3306 17.2292L70.6133 21.1081ZM151.287 28.1079V5.60728H142.411V0.378271H166.584V5.60728H157.707V28.1079H151.287ZM112.948 28.1079L125.312 0.378271H131.653L144.056 28.1079H137.32L134.857 22.1658H121.998L119.526 28.1079H112.948ZM132.838 17.2933L128.44 6.6808L124.025 17.2933H132.838Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.033 4.53956L0.00055542 21.7822L0 15.6708L12.9416 5.06079H0L0.00055542 0.282227H19.5841H26.226L21.033 4.53956Z",
    fill: "#EBB249"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgZakyatLogo);
export default __webpack_public_path__ + "static/media/zakyat-logo.4261433412a8a6949f39e3fa54fa6638.svg";
export { ForwardRef as ReactComponent };